export default __webpack_public_path__ + "static/media/profile_thumb.44d92c03.jpg";